// @flow
import React, { type Node } from 'react';
import { Link } from 'react-router-dom';
import { css } from 'styled-components/macro';

import { mergeClassNames } from 'utils/functions';

type LinkButtonProps = {
    to: string,
    flavor: string,
    className: string,
    children: Node,
    size: 'lg' | 'sm' | '';
};

// sync with the Button
const style = css`
    border: none;
    border-radius: ${props => props.theme.radiusSm};
`;

/**
 * A component for simplifying using bootstrap Button for navigating.
 * If `to` is a relative path, it will be a react-router Link. Otherwise it will use a regular anchor.
 **/
export class LinkButton extends React.Component<LinkButtonProps> {
    static defaultProps = {
        to: '',
        flavor: 'light',
        className: '',
        size: '',
    };

    render() {
        let { to, flavor, className, children, size, ...domProps } = this.props;
        className = mergeClassNames(
            'btn',
            `btn-${flavor}`,
            `${size ? 'btn-' + size : ''}`,
            className
        );

        // if absolute url, make it a regular link with an href,
        // if relative path, make it a react-router Link
        if (to.startsWith('http')) {
            return (
                <a href={to} className={className} css={style} {...domProps}>
                    {children}
                </a>
            );
        } else {
            return (
                <Link to={to} className={className} css={style} {...domProps}>
                    {children}
                </Link>
            );
        }
    }
}

export default LinkButton;
